const onGetDefaultStartEnDate = () => {
  const start_date = new Date(new Date().setDate(1));
  return [start_date, new Date()];
};
const handlerChoicesShortOption = (option) => {
  if (option === "default") {
    return onGetDefaultStartEnDate();
  } else if (option === "last_month") {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const start_date = new Date(year, month - 1, 1);
    const end_date = new Date(year, month, 0);
    return [start_date, end_date];
  }
};
export const checkInterval = (date) => {
  const inputDate = new Date(date);

  const resultDate = new Date(inputDate);
  resultDate.setMonth(resultDate.getMonth() - 1);
  if (resultDate.getDate() !== inputDate.getDate()) {
    resultDate.setDate(0);
  }
  return resultDate;
};
export const getTheLastMonth = () => {
  const date = new Date();
  date.setMonth(date.getMonth() - 1);
  return date.getDate();
};
export const getPreviousMonthInfo = () => {
  const today = new Date();
  const previousMonth = new Date(today.getFullYear(), today.getMonth(), 0);

  const monthNames = [
    "janeiro",
    "fevereiro",
    "março",
    "abril",
    "maio",
    "junho",
    "julho",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "dezembro",
  ];

  return {
    monthName: monthNames[previousMonth.getMonth()],
    lastDay: previousMonth.getDate(),
  };
};
export const getMonthRange = (monthIndex) => {
  const today = new Date(); const year =
    monthIndex > today.getMonth() ? today.getFullYear() - 1 : today.getFullYear();
  const start_date = new Date(year, monthIndex, 1);
  const end_date = new Date(year, monthIndex + 1, 0);
  return [start_date, end_date];
};

export const MONTH_NAMES_SHORT = [
  "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
  "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro",
];

export { handlerChoicesShortOption, onGetDefaultStartEnDate };



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFCe/BatchNFCe/helpers/index.js